import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import currencySymbol from './currencySymbol';
export default function () {
  Discussion.prototype.bountiesEnabled = Model.attribute('blomstraBountiesEnabled');
  Discussion.prototype.canEnableBounties = Model.attribute('blomstraBountiesCanEnable');
  Discussion.prototype.backers = Model.hasMany('backers');
  Discussion.prototype.totalBounty = Model.attribute('blomstraTotalBounty');
  Discussion.prototype.bountyCurrencySymbol = function () {
    return currencySymbol(Model.attribute('blomstraBountyCurrency').call(this));
  };
  Discussion.prototype.blomstraPtvPaid = Model.attribute('blomstraPtvPaid');
  Discussion.prototype.blomstraPtpPaid = Model.attribute('blomstraPtpPaid');
}